import { render, staticRenderFns } from "./_TypePropertiesPanel.vue?vue&type=template&id=45c9c4c2&scoped=true&"
import script from "./_TypePropertiesPanel.vue?vue&type=script&lang=js&"
export * from "./_TypePropertiesPanel.vue?vue&type=script&lang=js&"
import style0 from "./_TypePropertiesPanel.vue?vue&type=style&index=0&id=45c9c4c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c9c4c2",
  null
  
)

export default component.exports